import { v4 as uuidv4 } from 'uuid';

export const generateId = (asNumber = false): string | number => {
    const id = uuidv4();

    if (!asNumber) return id;

    const numericPart = id.replace(/-/g, '').slice(0, 12);
    return parseInt(numericPart, 16);
};
